import axios from 'axios';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { formatApiErrorMessage } from '../../utils';
import { apiEndpoints } from '../../constants';
import { notificationAlert } from '../notifications';
import { usersUploadStoreKey } from './usersUpload.const';

export const uploadUsers = createAsyncThunk(
  `${usersUploadStoreKey}/uploadUsers`,
  async (body: any, thunkAPI) => {
    try {
      const response = await axios.post(apiEndpoints.uploadPumbCreds(), body);
      thunkAPI.dispatch(
        notificationAlert('User documents uploaded', { variant: 'success' }),
      );
      return response.data;
    } catch (err: any) {
      thunkAPI.dispatch(
        notificationAlert(formatApiErrorMessage(err), {
          variant: 'error',
          persist: true,
        }),
      );
      throw new Error(err);
    }
  },
);
